import { SET_CART_DATA } from "../../actions/action.types";

const cartData = (state = [], action: any) => {
  if (action.type === SET_CART_DATA) return action.payload;
  return state;
};

export default cartData;
